export default {
  'alerts.pageTitle': 'Alerts',
  'alerts.tab.channels': 'Channels',
  'alerts.tab.rules': 'Rules',
  'alerts.tab.events': 'Events',

  'alerts.channels.name': 'Name',
  'alerts.channels.type': 'Type',
  'alerts.channels.enabled': 'Enabled',
  'alerts.channels.summary': 'Summary',
  'alerts.channels.actions': 'Actions',
  'alerts.channels.create': 'New Channel',
  'alerts.channels.createTitle': 'New Channel',
  'alerts.channels.editTitle': 'Edit Channel',
  'alerts.channels.delete': 'Delete',
  'alerts.channels.deleteConfirm': 'Delete this channel?',
  'alerts.channels.deleteHint': 'References in rules will be removed automatically',
  'alerts.channels.loadFailed': 'Load failed',
  'alerts.channels.saveFailed': 'Save failed',
  'alerts.channels.deleted': 'Deleted',
  'alerts.channels.deleteFailed': 'Delete failed',
  'alerts.channels.created': 'Created',
  'alerts.channels.updated': 'Updated',
  'alerts.channels.toggleFailed': 'Toggle failed',
  'alerts.channels.test': 'Test Push',
  'alerts.channels.testOk': 'Test sent. Check the destination channel',
  'alerts.channels.testFailed': 'Test failed',
  'alerts.channels.empty': 'No channels. Create a Telegram / DingTalk / Lark / Webhook channel',

  'alerts.channels.tg.chatIdTip': 'chat_id number / -100xxx for group / @groupname',
  'alerts.channels.dd.secret': 'Sign Secret (optional)',
  'alerts.channels.dd.secretTip': 'Required if DingTalk robot uses sign mode',
  'alerts.channels.dd.atUsers': '@Users (optional)',
  'alerts.channels.dd.atUsersTip': 'comma-separated mobile numbers',
  'alerts.channels.lark.secret': 'Sign Secret (optional)',
  'alerts.channels.wb.signMethod': 'Sign Method',
  'alerts.channels.wb.secret': 'Secret',
  'alerts.channels.wb.secretTip': 'Required when signMethod=hmac-sha256',

  'alerts.rules.name': 'Name',
  'alerts.rules.namePlaceholder': 'e.g. Provider error → ops DingTalk',
  'alerts.rules.enabled': 'Enabled',
  'alerts.rules.eventType': 'Event Type',
  'alerts.rules.eventTypePlaceholder': 'Pick the event to listen',
  'alerts.rules.eventTypes': 'Events',
  'alerts.rules.eventTypesPlaceholder': 'Pick one or more events',
  'alerts.rules.eventTypesRequired': 'Pick events, or enable "all events"',
  'alerts.rules.channels': 'Target Channels',
  'alerts.rules.channelsPlaceholder': 'Pick one or more channels',
  'alerts.rules.throttle': 'Throttle (sec)',
  'alerts.rules.throttleTip':
    '0 = no throttle (push every event); > 0 = dedupe per (event, channel) within the window. 300s (5 min) recommended to avoid spam',
  'alerts.rules.throttleOff': 'No throttle',
  'alerts.rules.throttleZeroHint': '⚠ No throttle: every PUB is pushed. May spam destinations.',
  'alerts.rules.allChannels': 'All channels',
  'alerts.rules.allChannelsTip':
    'Ignore the channel list below and broadcast to every enabled channel (including future ones).',
  'alerts.rules.allChannelsTag': 'All channels',
  'alerts.rules.channelsRequired': 'Pick channels, or enable "all channels"',
  'alerts.rules.allEvents': 'All events',
  'alerts.rules.allEventsTip':
    'Ignore the event picker below and match every PUB. Useful for "everything → ops group" without one-rule-per-event boilerplate.',
  'alerts.rules.allEventsTag': 'All events',
  'alerts.rules.conditions': 'Conditions (JSON, optional)',
  'alerts.rules.conditionsTip':
    'e.g. {"provider": "apimart"} only for apimart; {"recovered_min": 10} only when recovered ≥ 10; empty = no condition',
  'alerts.rules.conditionsInvalid': 'Conditions JSON is invalid',
  'alerts.rules.actions': 'Actions',
  'alerts.rules.create': 'New Rule',
  'alerts.rules.createTitle': 'New Rule',
  'alerts.rules.editTitle': 'Edit Rule',
  'alerts.rules.delete': 'Delete',
  'alerts.rules.deleteConfirm': 'Delete this rule?',
  'alerts.rules.deleted': 'Deleted',
  'alerts.rules.deleteFailed': 'Delete failed',
  'alerts.rules.created': 'Created',
  'alerts.rules.updated': 'Updated',
  'alerts.rules.saveFailed': 'Save failed',
  'alerts.rules.loadFailed': 'Load failed',
  'alerts.rules.toggleFailed': 'Toggle failed',
  'alerts.rules.emit': 'Emit Once',
  'alerts.rules.emitOk': 'Emitted. Check the destination channel',
  'alerts.rules.emitFailed': 'Emit failed',
  'alerts.rules.empty': 'No rules. Create one to route events to channels',
  'alerts.rules.viewInCatalog': 'Click to view event spec',

  'alerts.events.sentAt': 'Time',
  'alerts.events.eventType': 'Event',
  'alerts.events.rule': 'Rule',
  'alerts.events.channel': 'Channel',
  'alerts.events.status': 'Status',
  'alerts.events.title': 'Title',
  'alerts.events.error': 'Error',
  'alerts.events.detail': 'Event Detail',
  'alerts.events.loadFailed': 'Load failed',
  'alerts.events.empty': 'No events yet. Pushed events appear here (kept indefinitely)',

  'alerts.channelType.telegram.label': 'Telegram',
  'alerts.channelType.telegram.desc': 'Official Bot API, free, Markdown supported',
  'alerts.channelType.dingtalk.label': 'DingTalk',
  'alerts.channelType.dingtalk.desc': 'DingTalk group robot, optional sign mode',
  'alerts.channelType.lark.label': 'Feishu / Lark',
  'alerts.channelType.lark.desc': 'Feishu / Lark group robot, optional sign',
  'alerts.channelType.webhook.label': 'Generic Webhook',
  'alerts.channelType.webhook.desc': 'JSON POST, works with Slack / n8n / custom',

  'alerts.eventType.provider_error.label': 'Provider Error',
  'alerts.eventType.provider_error.desc': 'Provider error rate exceeds threshold within 1 min',
  'alerts.eventType.stale_recover.label': 'Stale Task Recovered',
  'alerts.eventType.stale_recover.desc': 'Background scan auto-failed timed-out tasks',
  'alerts.eventType.llm_limiter.label': 'LLM Backlog',
  'alerts.eventType.llm_limiter.desc': 'LLM rate-limit queue size persistently high',
  'alerts.eventType.health.label': 'Service Health',
  'alerts.eventType.health.desc': 'auth / drama / gateway /health changed (down / up)',
  'alerts.eventType.payment_paid.label': 'Top-up Paid',
  'alerts.eventType.payment_paid.desc': 'Stripe checkout completed + credits granted',
  'alerts.eventType.user_registered.label': 'New User',
  'alerts.eventType.user_registered.desc': 'A new user signed up',
  'alerts.eventType.credit_abnormal.label': 'Credit Burn',
  'alerts.eventType.credit_abnormal.desc': 'Single user 1h spend exceeds threshold',
  'alerts.eventType.task_failed.label': 'Task Failed',
  'alerts.eventType.task_failed.desc': 'Canvas / character / scene / storyboard task failed',
  'alerts.eventType.daily_report.label': 'Daily Report',
  'alerts.eventType.daily_report.desc': 'Daily 09:00 platform digest (signups / topups / spend)',

  'alerts.status.sent.label': 'Sent',
  'alerts.status.failed.label': 'Failed',
  'alerts.status.throttled.label': 'Throttled',

  'alerts.level.critical.label': 'Critical',
  'alerts.level.warn.label': 'Warning',
  'alerts.level.info.label': 'Info',
  'alerts.source.drama.label': 'drama',
  'alerts.source.auth.label': 'auth',

  'alerts.tab.catalog': 'Event Catalog',
  'alerts.catalog.intro':
    'Backend hard-coded alert events. Read here first to understand triggers and payload fields before creating rules.',
  'alerts.catalog.trigger': 'Trigger',
  'alerts.catalog.fields': 'Payload Fields (use in conditions / message rendering)',
  'alerts.catalog.subprojections': 'Current subprojections',
  'alerts.catalog.noSubprojection': 'No rule subscribes to this event. PUBs go nowhere.',
  'alerts.catalog.stats24h': 'Last 24 hours',
  'alerts.catalog.statSent': 'Sent',
  'alerts.catalog.statFailed': 'Failed',
  'alerts.catalog.statThrottled': 'Throttled',
  'alerts.catalog.createRule': 'Create rule for this event',
  'alerts.catalog.emit': 'Emit test',
  'alerts.catalog.viewEvents': 'View history',
  'alerts.catalog.conditionExample': 'Condition example',
  'alerts.catalog.numericHint': 'Numeric fields support _min / _max suffix',
  'alerts.catalog.loadFailed': 'Load failed',
  'alerts.catalog.emitOk': 'Emitted. Subscribed rules will forward to their channels',
  'alerts.catalog.emitFailed': 'Emit failed',
  'alerts.catalog.flow': 'Push pipeline',
  'alerts.catalog.detail': 'Trigger / Fields',

  'alerts.eventType.provider_error.trigger':
    'In a 60s window, a provider has ≥ 5 calls and failure rate ≥ 50%. Deduped within the window.',
  'alerts.eventType.stale_recover.trigger':
    'Background scan finds pending/processing tasks older than cutoff (default 35min), marks them failed + refunds; PUBs when recovered > 0.',
  'alerts.eventType.llm_limiter.trigger':
    'LLM rate-limit queue probed every 30s; PUB only after waiting ≥ 5 for 2 consecutive ticks AND last PUB was > 5min ago.',
  'alerts.eventType.health.trigger':
    'auth pings auth / drama / gateway /health every 60s. PUB only on status change (OK→FAIL critical / FAIL→OK recovery).',
  'alerts.eventType.payment_paid.trigger':
    'Stripe checkout.session.completed webhook handled: credits granted + order marked paid → PUB.',
  'alerts.eventType.user_registered.trigger':
    'UserService.CreateUser succeeds (email signup / phone signup / first OAuth login).',
  'alerts.eventType.credit_abnormal.trigger':
    '(Reserved) Periodic scan over credit_ledger_entries; PUB when single user 1h spend exceeds threshold. Not enabled yet.',
  'alerts.eventType.task_failed.trigger':
    'drama task_worker.notifyFailed: any of 5 paths (submit 4xx / submit retries exhausted / poll missing task_id / poll over-age / upstream failed).',
  'alerts.eventType.daily_report.trigger':
    'Daily UTC 01:00 (Beijing 09:00) cron aggregates the past 24h stats and PUBs once.',

  'alerts.eventType.provider_error.field.provider': 'Provider name (apimart / wanx / kling …)',
  'alerts.eventType.provider_error.field.error_count': 'Failure count in window',
  'alerts.eventType.provider_error.field.total_count': 'Total calls in window',
  'alerts.eventType.provider_error.field.window_sec': 'Window length (sec, fixed 60)',
  'alerts.eventType.stale_recover.field.business': 'Business key (canvas_image / character_canonical / scene_sheet …)',
  'alerts.eventType.stale_recover.field.recovered': 'Number of tasks recovered',
  'alerts.eventType.llm_limiter.field.waiting': 'Current waiting (queued) count',
  'alerts.eventType.llm_limiter.field.holding': 'Current holding (active) count',
  'alerts.eventType.llm_limiter.field.max': 'Configured concurrency limit',
  'alerts.eventType.llm_limiter.field.threshold': 'Threshold (default 5)',
  'alerts.eventType.health.field.service': 'Service name (auth / drama / gateway)',
  'alerts.eventType.health.field.status': 'Current status (ok / down)',
  'alerts.eventType.health.field.error': 'Error message (set when down)',
  'alerts.eventType.payment_paid.field.user_id': 'User ID (hex)',
  'alerts.eventType.payment_paid.field.user_email': 'User email',
  'alerts.eventType.payment_paid.field.order_no': 'Order number',
  'alerts.eventType.payment_paid.field.credits': 'Credits granted',
  'alerts.eventType.payment_paid.field.amount_usd': 'Amount (USD, string)',
  'alerts.eventType.payment_paid.field.source': 'Order source (custom / pack)',
  'alerts.eventType.payment_paid.field.pack_code': 'Pack code (source=pack)',
  'alerts.eventType.user_registered.field.user_id': 'New user ID (hex)',
  'alerts.eventType.user_registered.field.user_email': 'New user email',
  'alerts.eventType.user_registered.field.nickname': 'Nickname',
  'alerts.eventType.credit_abnormal.field.user_id': 'User ID (hex)',
  'alerts.eventType.credit_abnormal.field.user_email': 'User email',
  'alerts.eventType.credit_abnormal.field.spent_1h': 'Spend in last hour',
  'alerts.eventType.task_failed.field.kind': 'Task kind (canvas_image / canvas_video / character_shot …, 14 total)',
  'alerts.eventType.task_failed.field.job_id': 'Job ID',
  'alerts.eventType.task_failed.field.user_id': 'Triggering user ID',
  'alerts.eventType.task_failed.field.reason': 'Failure reason (raw)',
  'alerts.eventType.daily_report.field.new_users': '24h new signups',
  'alerts.eventType.daily_report.field.topup_count': '24h topup count',
  'alerts.eventType.daily_report.field.topup_credits': '24h topup credits total',
  'alerts.eventType.daily_report.field.credit_spent': '24h credit spent total',
};
